<script>
	// Componentes Svelte
	import { Router, Link, link , Route }   from "svelte-routing";
	import { 
		linkAV,
		linkConheca,
		linkSolicite,
		linkBoletoFacil
	} from './store.js';

	// Componentes
	import Header 				from "./components/Header.svelte";
	import Footer 				from "./components/Footer.svelte";
	import Aviso 				from "./components/Aviso.svelte";

	// Rotas/Pages
	import Home 					from "./routes/Home.svelte";
	import Imoveis 					from "./routes/Imoveis.svelte";
	import Anuncie 					from "./routes/Anuncie.svelte";
	import Imovel 					from "./routes/Imovel.svelte";
	import SoliciteImovel 			from "./routes/SoliciteImovel.svelte";
	import Contato 					from "./routes/Contato.svelte";
	import Sobre 					from "./routes/Sobre.svelte";
	import Favoritos 				from "./routes/Favoritos.svelte";
	import FavoritosImobiliaria 	from "./routes/FavoritosImobiliaria.svelte";
	import FavoritosAmigos 			from "./routes/FavoritosAmigos.svelte";
	import Oops 					from "./routes/Oops.svelte";
	import Obrigado 				from "./routes/Obrigado.svelte";
	import TrabalheConosco			from "./routes/TrabalheConosco.svelte";
	import TrabalheCondominios		from "./routes/TrabalheCondominios.svelte";	
	import DocumentacaoNecessaria	from "./routes/DocumentacaoNecessaria.svelte";
	import GarantiasLocaticias		from "./routes/GarantiasLocaticias.svelte";
	import FichasCadastrais			from "./routes/FichasCadastrais.svelte";
	import AdministracaoCondominios	from "./routes/AdministracaoCondominios.svelte";
	import SoliciteProposta			from "./routes/SoliciteProposta.svelte";
	import ServicosProprietarios	from "./routes/ServicosProprietarios.svelte";
	import NotFound					from "./routes/NotFound.svelte";
	import FichaFiador				from "./routes/FichaFiador.svelte";
	import FichaPessoaFisica		from "./routes/FichaPessoaFisica.svelte";
	import FichaPessoaJuridica		from "./routes/FichaPessoaJuridica.svelte";
	import SindicoProfissional		from "./routes/SindicoProfissional.svelte";
	import GestaoTotal				from "./routes/GestaoTotal.svelte";
	import CartaoDoSindico			from "./routes/CartaoDoSindico.svelte";
	import ParcelinhaDigital		from "./routes/ParcelinhaDigital.svelte";
	import DebitoEmConta			from "./routes/DebitoEmConta.svelte";
	import AssessoriaContabil		from "./routes/AssessoriaContabil.svelte";
	import Desocupacao				from "./routes/Desocupacao.svelte";
	import ManualCondominios		from "./routes/ManualCondominios.svelte";
	import Parceiros				from "./routes/Parceiros.svelte";
	import PromocaoTrintou			from "./routes/PromocaoTrintou.svelte";
	import PromocaoBlack			from "./routes/PromocaoBlack.svelte";
	import PromocaoCarencia			from "./routes/PromocaoCarencia.svelte";
	import PoliticaPrivacidade		from "./routes/PoliticaPrivacidade.svelte";

	// Code
	let url = '';
	let menu	= [
		{
			title: "Condomínios",
			subitems: [
				{
					title: 'Administração de condomínios',
					href: '/administracao-condominios'
				},
				{
					title: 'Solicite uma proposta',
					href: '/solicite-proposta'
				},
				{
					title: 'Cartão do síndico',
					href: '/cartao-do-sindico'
				},
				{
					title: 'Débito em conta',
					href: '/debito-em-conta'
				},
				{
					title: 'Parcelinha Digital',
					href: '/parcelinha-digital'
				},
				{
					title: 'Rede de parceiros',
					href: '/parceiros'
				},
				{
					title: 'Trabalhe nos condomínios',
					href: '/trabalhe-condominios'
				},
				{ separator: true },
				{
					title: 'Conheça o Bona Digital',
					href: $linkConheca,
					target: '_blank',
				},
				{
					title: 'Acesse o Bona Digital',
					href: $linkAV,
					target: '_blank',
				},
				{
					title: 'Solicite sua senha',
					href: $linkSolicite,
					target: '_blank',
				},
				{ separator: true },
				{
					title: 'Manual de gestão de condomínios',
					href: 'https://bonaimoveis.com.br/manualcondominios/',
					target: '_blank',
				}
			]
		},
		{
			title: "Imóveis",
			subitems: [
				{
					title: 'Imóveis para alugar',
					href: `/imoveis/locacao#tipo_negociacao=2&cidade=Porto%20Alegre&valor_de=0&valor_ate=0&valor_completo=0`,
					useLink: false,
					// forceReload: true
				},
				{
					title: 'Mude agora, pague depois',
					href: `/carencia`,
					useLink: false,
					// forceReload: true
				},				
				{
					title: 'Imóveis para comprar',
					href: `/imoveis/vendas#tipo_negociacao=1&cidade=Porto%20Alegre`,
					useLink: false,
					// forceReload: true
				},
				{
					title: 'Solicite um imóvel',
					href: '/solicite'
				},
				{
					title: 'Anuncie seu imóvel',
					href: '/anuncie'
				},
				{
					title: 'Documentação necessária',
					href: '/documentacao-necessaria'
				},
				{
					title: 'Garantias locatícias',
					href: '/garantias-locaticias'
				},
				{
					title: 'Fichas Cadastrais',
					href: '/fichas-cadastrais'
				},
				{
					title: 'Serviços para Proprietários',
					href: '/servicos-para-proprietarios'
				},
				{
					title: 'Parcelinha Digital',
					href: '/parcelinha-digital'
				},
				{
					title: 'Favoritos',
					href: '/favoritos'
				},
				{ separator: true },
				{
					title: '2° Via boletos e financeiro',
					href: $linkAV,
					target: '_blank',
				},
				{
					title: 'Solicite sua senha',
					href: $linkSolicite,
					target: '_blank',
				},
			]
		},
		{
			title: "Seguros",
			subitems: [
				{
					title: 'Comercial',
					href: 'http://bonaimoveis.com.br/SeguroComercial/',
					target: '_blank'
				},
				{
					title: 'Residencial',
					href: 'http://bonaimoveis.com.br/SeguroResidencial/',
					target: '_blank'
				},
			]
		},
		{
			title: 'Sobre',
			href: '/sobre'
		},
		{
			title: 'Contato',
			subitems: [
				{
					title: 'Entre em contato',
					href: '/contato'
				},
				{
					title: 'Trabalhe na Bona Imóveis',
					href: '/trabalhe-conosco'
				},
				{
					title: 'Trabalhe nos condomínios',
					href: '/trabalhe-condominios'
				},
			]
		},
		{
			title: 'Área do Cliente',
			classe: 'btn btn-secondary',
			href: $linkAV,
			target: '_blank',
			classeli: 'hidden-xs hidden-sm'
		}
	];
	let menuSecondary	= [
		{
			title: 'Menu',
			icon: '<i class="fal fa-bars"></i>',
			classe: 'btn btn-border-secondary',
			href: 'javascript:document.querySelector("header.header--hidden").classList.toggle("hidden");',
		},
		{
			title: 'Boleto Fácil',
			icon: '<i class="fal fa-bullseye-pointer"></i>',
			classe: 'btn btn-border-secondary',
			href: $linkBoletoFacil,
			target: '_blank'
		},
		{
			title: 'Área do Cliente',
			icon: '<i class="fal fa-id-badge"></i>',
			classe: 'btn btn-border-secondary',
			href: $linkAV,
			target: '_blank'
		}
	];

</script>

<Router url="{url}">
	<Header classe="" menu={menu} menuSecondary={menuSecondary} logoHeight="65px" />
	<main class="fadeIn">
		<div class="routes">
			<!-- Rotas -->
			<Route path="/"><Home /></Route>
			<Route path="/home"><Home /></Route>
			<Route path="/detalhe/:nt/:id/:extra" let:params>
				<section class="conteudo-internas imovel-detalhe">
					<Imovel nt="{params.nt}" id="{params.id}" />
				</section>
			</Route>
			<Route path="/go-imovel/:nt/:id/:extra" let:params>
				<section class="conteudo-internas imovel-detalhe">
					<Imovel nt="{params.nt}" id="{params.id}" shareCallback={true} />
				</section>
			</Route>
			<Route path="/imovel/:nt/:id/:extra" let:params>
				<section class="conteudo-internas imovel-detalhe">
					<Imovel nt="{params.nt}" id="{params.id}" />
				</section>
			</Route>
			<Route path="/trabalhe-conosco">
				<section class="conteudo-internas">
					<TrabalheConosco />
				</section>
			</Route>
			<Route path="/trabalhe-condominios">
				<section class="conteudo-internas">
					<TrabalheCondominios />
				</section>
			</Route>
			<Route path="imoveis/vendas" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="imoveis/locacao" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="trintou" let:params>
				<Home />
			</Route>
			<Route path="black" let:params>
				<Home />
			</Route>
			<Route path="carencia" let:params>
				<section class="conteudo-internas">
					<PromocaoCarencia {...params}/>
				</section>
			</Route>
			<Route path="imoveis" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="administracao-condominios">
				<section class="conteudo-internas">
					<AdministracaoCondominios />
				</section>
			</Route>
			<Route path="cartao-do-sindico">
				<section class="conteudo-internas">
					<CartaoDoSindico />
				</section>
			</Route>
			<Route path="parcelinha-digital">
				<section class="conteudo-internas">
					<ParcelinhaDigital />
				</section>
			</Route>
			<Route path="garantias-locaticias">
				<section class="conteudo-internas">
					<GarantiasLocaticias />
				</section>
			</Route>
			<Route path="solicite-proposta">
				<section class="conteudo-internas">
					<SoliciteProposta />
				</section>
			</Route>
			<Route path="debito-em-conta">
				<section class="conteudo-internas">
					<DebitoEmConta />
				</section>
			</Route>	
			<Route path="servicos-para-proprietarios">
				<section class="conteudo-internas">
					<ServicosProprietarios />
				</section>
			</Route>
			<Route path="anuncie">
				<section class="conteudo-internas">
					<Anuncie />
				</section>
			</Route>
			<Route path="solicite">
				<section class="conteudo-internas">
					<SoliciteImovel />
				</section>
			</Route>
			<Route path="contato">
				<section class="conteudo-internas mb-0 pb-0">
					<Contato />
				</section>
			</Route>
			<Route path="sobre">
				<section class="conteudo-internas">
					<Sobre />
				</section>
			</Route>
			<Route path="favoritos">
				<section class="conteudo-internas">
					<Favoritos />
				</section>
			</Route>
			<Route path="favoritos-imobiliaria">
				<section class="conteudo-internas">
					<FavoritosImobiliaria />
				</section>
			</Route>
			<Route path="favoritos-amigo">
				<section class="conteudo-internas">
					<FavoritosAmigos />
				</section>
			</Route>
			<Route path="documentacao-necessaria">
				<section class="conteudo-internas">
					<DocumentacaoNecessaria />
				</section>
			</Route>
			<Route path="fichas-cadastrais">
				<section class="conteudo-internas">
					<FichasCadastrais />
				</section>
			</Route>
			<Route path="ficha-fiador">
				<section class="conteudo-internas">
					<FichaFiador />
				</section>
			</Route>
			<Route path="ficha-locatario-pessoa-fisica">
				<section class="conteudo-internas">
					<FichaPessoaFisica />
				</section>
			</Route>
			<Route path="ficha-locatario-pessoa-juridica">
				<section class="conteudo-internas">
					<FichaPessoaJuridica />
				</section>
			</Route>
			<Route path="ficha-locatario-pessoa-juridica">
				<section class="conteudo-internas">
					<FichaPessoaJuridica />
				</section>
			</Route>
			<Route path="manual-condominios">
				<section class="conteudo-internas">
					<ManualCondominios />
				</section>
			</Route>
			<Route path="parceiros">
				<section class="conteudo-internas">
					<Parceiros />
				</section>
			</Route>
			<Route path="politica-de-privacidade">
				<section class="conteudo-internas">
					<PoliticaPrivacidade />
				</section>
			</Route>
			<Route path="oops">
				<section class="conteudo-internas">
					<Oops />
				</section>
			</Route>
			<Route path="obrigado">
				<section class="conteudo-internas">
					<Obrigado />
				</section>
			</Route>
			<Route>
				<section class="conteudo-internas">
					<NotFound />
				</section>
			</Route>			
		</div>
	</main>
	<Footer/>
	<Aviso />
</Router>